import { render } from "./PortraitManagement.vue?vue&type=template&id=76640811&scoped=true"
import script from "./PortraitManagement.vue?vue&type=script&lang=js"
export * from "./PortraitManagement.vue?vue&type=script&lang=js"

import "./PortraitManagement.vue?vue&type=style&index=0&id=76640811&scoped=true&lang=scss"
import "./PortraitManagement.vue?vue&type=style&index=1&id=76640811&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76640811"]])

export default __exports__